const customAvatarStyle = () => {
	return {
		image: {
			width: '100%',
			height: '100%',
			objectFit: 'contain',
		},
		inlineIcon: {
			height: 16,
			width: 16,
			objectFit: 'cover',
			marginRight: 8,
		},
	};
};

export default customAvatarStyle;
